module.exports = __webpack_public_path__ + "img/webpack.dda8a93d.png";